import { ReactNode } from 'react'
import { IconButton, Modal, Paper } from '@mui/material'

import CloseIcon from '@mui/icons-material/Close'

import { useStyles } from './styles'

interface IModalWrapperProps {
  open: boolean
  onClose: () => void
  children: ReactNode
  className?: string
  withoutX?: boolean
  title?: string
}

const ModalWrapper = ({
  children,
  open,
  onClose,
  className,
  withoutX,
  title,
}: IModalWrapperProps) => {
  const classes = useStyles()

  const handleBackdropClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    onClose()
  }

  return (
    <Modal
      open={open}
      onClose={handleBackdropClick}
      sx={{
        backdropFilter: 'blur(5px)',
        backgroundColor: 'rgba(0,0,0, 0.5)',
        // zIndex: 10000,
      }}
    >
      <Paper className={`${classes.modalWrapper} ${className}`}>
        {!withoutX && (
          <IconButton className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        )}
        {title && <h4 className={classes.title}>{title}</h4>}
        {children}
      </Paper>
    </Modal>
  )
}

export { ModalWrapper }
